/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 16/01/2018
 * Time: 18h01
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
factory('CustomerPost_Resource',["$resource","$location",
    function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/customerPosts/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                save  : { method: 'POST', url: baseUrl+'rest/customerPosts/'},
            }
        );
    }
]);

angular.module('FlexyBeautyApp.services').
factory('CustomerPost',["CustomerPost_Resource","CustomerPostData",
    function (CustomerPost_Resource,CustomerPostData)
    {
        var CustomerPost = function (resource)
        {
            this.id = null,
            this.companyImageId = null,
            this.customerId = null,
            this.customerFirstName = null,
            this.customerLastName = null,
            this.fromDeviceId = null,
            this.rating = null,
            this.customerAuthPublish = false,
            this.proAuthPublish = false,
            this.timeCreated = null,
            this.timePublished = null,
            this.text = "",
            this.title = "",
            this.isDeleted = false;

            if(resource !== undefined && resource !== null)
                this.loadObject(resource);

            CustomerPostData.add(this);
        };

        CustomerPost.prototype.setId = function(id)
        {
            this.id = id;
        };
        CustomerPost.prototype.getId = function()
        {
            return this.id;
        };

        CustomerPost.prototype.loadObject = function(object)
        {
            if (object)
            {
                if (!this.id)
                    this.id = object.id;
                if (object.companyImageId)
                    this.companyImageId = object.companyImageId;
                if (object.customerId)
                    this.customerId = object.customerId;
                if (object.customerFirstName)
                    this.customerFirstName = object.customerFirstName;
                if (object.customerLastName)
                    this.customerLastName = object.customerLastName;
                if (object.fromDeviceId)
                    this.fromDeviceId = object.fromDeviceId;
                this.rating = object.rating;
                this.customerAuthPublish = object.customerAuthPublish;
                this.proAuthPublish = object.proAuthPublish;
                this.timeCreated = object.timeCreated;
                this.timePublished = object.timePublished;
                this.text = object.text;
                this.title = object.title;
                this.isDeleted = object.isDeleted;
            }
        };


        CustomerPost.prototype.getObjectResource = function()
        {
            var newPost = new CustomerPost_Resource();
            newPost.id = this.id;
            newPost.rating = this.rating;
            newPost.customerAuthPublish = this.customerAuthPublish;
            newPost.proAuthPublish = this.proAuthPublish;
            newPost.timeCreated = this.timeCreated;
            newPost.timePublished = this.timePublished;
            newPost.text = this.text;
            newPost.title = this.title;
            newPost.isDeleted = this.isDeleted;
            newPost.customerId = this.customerId;
            newPost.companyImageId = this.companyImageId;
            newPost.fromDeviceId = this.fromDeviceId;
            return newPost;
        }
        return CustomerPost;
    }
]);

angular.module('FlexyBeautyApp.services').
factory('CustomerPostSrv',["$log","ServerSrv","CustomerPost_Resource","CustomerPostData","CustomerPost",
    function ($log,ServerSrv,CustomerPost_Resource,CustomerPostData,CustomerPost)
    {
        var customerPostSrv = {};

        customerPostSrv.query = function(successFunction,errorFunction)
        {
            CustomerPost_Resource.query(
                {}, //params
                function (data) {

                    CustomerPostData.clear();
                    for(var i=0;i<data.length;i++)
                    {
                        new CustomerPost(data[i]);
                    }

                    if (successFunction!== undefined)
                        successFunction();
                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                }
            );
        };

        customerPostSrv.save = function(customerPost,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(customerPostSrv.saveSync, customerPost, successFunction, errorFunction);
        };

        customerPostSrv.saveSync = function(customerPost,successFunction,errorFunction)
        {
            //$timeout (function () {

            var customerPostRes = customerPost.getObjectResource();
            customerPostRes.$save({}, //no params
                function (data) {
                    try{
                        customerPost.setId(data.id);
                        if (successFunction !== undefined && successFunction !== null)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        customerPostSrv.remove = function(customerPost,successFunction,errorFunction)
        {
            CustomerPostData.remove(customerPost);
            ServerSrv.startSavingProcess(customerPostSrv.removeSync, customerPost, successFunction, errorFunction);
        };
       
        customerPostSrv.removeSync = function(customerPost,successFunction,errorFunction)
        {
            var customerPostRes = customerPost.getObjectResource();
            customerPostRes.$remove({id:customerPost.getId()}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };

        return customerPostSrv;
    }
]);


angular.module('FlexyBeautyApp.services').
factory('CustomerPostData', ["$log",
    function($log) {
        var customerPostData = {
            indexCustomerPosts : [], //Used as Index
            activeCustomerPosts : [],
            deletedCustomerPosts : []
        };

        customerPostData.getPostsByCustomerId = function(customerId) {
            var posts = [];
            for (var i=0;i<this.activeCustomerPosts.length;i++)
                if (this.activeCustomerPosts[i].customerId===customerId)
                    posts.push(this.activeCustomerPosts[i]);
            return posts;
        }

        customerPostData.getByIndex = function(servIndex) {
            if (servIndex >= 0 && servIndex < this.indexCustomerPosts.length) {
                return this.indexCustomerPosts[servIndex];
            }
            return null;
        }

        customerPostData.getById = function(customerPostId) {
            for (var i=0;i<this.indexCustomerPosts.length;i++)
                if (this.indexCustomerPosts[i].id===customerPostId)
                    return this.indexCustomerPosts[i];
            return null;

        }

        customerPostData.getIndexOf = function(customerPost) {
            if (customerPost)
                return this.indexCustomerPosts.indexOf(customerPost);
            return -1;
        }

        customerPostData.add = function(customerPost) {
            var customerPostArray = this.activeCustomerPosts;
            if (customerPost.isDeleted)
                customerPostArray =  this.deletedCustomerPosts;
            var index =  this.indexCustomerPosts.indexOf(customerPost);
            if (index!==-1)
            {
                var realIndex = customerPostArray.indexOf(customerPost);
                if (realIndex===-1)
                    customerPostArray.push(customerPost);
            }
            else
            {
                index = this.indexCustomerPosts.length;
                this.indexCustomerPosts.push(customerPost);
                customerPostArray.push(customerPost);
            }
            return index;
        }

        //Soft Remove
        customerPostData.remove = function(customerPost) {
            var index =  this.activeCustomerPosts.indexOf(customerPost);
            if (index!==-1)
            {
                this.activeCustomerPosts.splice(index, 1);
                this.deletedCustomerPosts.push(customerPost);
                customerPost.isDeleted=true;
            }
        }

        customerPostData.getActiveList =  function()
        {
            return this.activeCustomerPosts;
        }

        customerPostData.clear = function() {
            customerPostData.indexCustomerPosts = [];
            customerPostData.activeCustomerPosts = [];
            customerPostData.deletedCustomerPosts = [];
        }

        customerPostData.getDeletedList = function() {
            return customerPostData.deletedCustomerPosts;
        }
        return customerPostData;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/CustomerPost.js